import { Component, OnInit } from '@angular/core';
import { Events, NavParams } from 'ionic-angular';


import { HomePage } from '../home/home';
import { NohehutPage } from '../nohehut/nohehut';

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage implements OnInit {
  selectedIndex: any = 0;
  mercazType: any = 0;
  hideTabsNohehut: boolean = false;
  mercazHideNohehut: any = 50;
  tab1Root = HomePage;
  tab2Root = 'NohehutPage';
  tab3Root = 'NershamimmainPage';
  tab4Root = 'NohehutmainPage';
  tab5Root = 'PaymentsmainPage';

  constructor(public navParams: NavParams,
    public events: Events,) {
    // this.mercazType = navParams.get('mercazType');
    this.selectedIndex = navParams.get('selectedIndex') || 0;

    // events.subscribe('tabsEvent', (data) => {
    //   this.mercazType = data['mercazType'];
    //   console.log("mercazType tabs: ", this.mercazType);
    //   if (this.mercazType == 1) {
    //     console.log("hide tabs");
    //     this.hideTabsNohehut = true;
    //   }
    // });



  }

  ngOnInit(): void {
    let storageMercazType: any = Number(localStorage.getItem('mercazType'));
    if (storageMercazType && storageMercazType == this.mercazHideNohehut) {
      this.hideTabsNohehut = true;
      console.log("hide tabs onint");
    }
  }



  doChange(event) {
    // alert("change" + JSON.stringify(event))
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts